import { useFeatureFlags } from '@usap/core'

const useProductProtectionSubtext = (): false | true => {
  const { f26 } = useFeatureFlags() as any

  if (typeof f26 !== 'undefined' && (f26 === 'b' || f26 === true || f26 === 1 || f26 === '1')) {
    return true
  }
  return false
}

export {
  useProductProtectionSubtext,
}
